import _ from 'lodash'
import { loading, blankResponseArray } from '../constants'
import { ResponseArray } from '../types'
import { IUserFilter, IUserFilterOn, IUser, IUserSearchFilter } from './types'

export const blankUserArray: ResponseArray<IUser> = _.assign(
  [],
  blankResponseArray,
)

export const loadingUsers: ResponseArray<IUser> = _.assign(
  [],
  blankUserArray,
  loading,
)

export const blankUser: IUser = {
  UserId: 0,
  Username: '',
  Email: '',
  AuthProviderType: '',
  DateCreated: new Date(),
  Disabled: false,
  Name: '',
  LastName: '',
  Roles: [],
  SalesRepPermissions: [],
  CustomerPermissions: [],
  DisabledByUserName: '',
  Comment: '',
  SalesRepPermissionRequests: [],
  CustomerPermissionRequests: [],
}

export const loadingUser: IUser = _.assign(blankUser, loading)

export const blankFilterOn: IUserFilterOn = {
  Name: false,
  Username: false,
  LastName: false,
  SalesRepPermissions: false,
  CustomerPermissions: false,
}

export const blankFilter: IUserFilter = {
  Name: '',
  Username: '',
  LastName: '',
  SalesRepPermissions: '',
  CustomerPermissions: '',
}

export const blankSearchFilters: IUserSearchFilter = {
  page: 1,
  sortBy: 'DateCreated',
  sortDesc: true,
  userName: '',
  firstName: '',
  lastName: '',
  salesRepNumber: '',
  customerNumber: '',
  pageSize: 10,
}
